// tslint:disable: max-line-length
import { formatNumber } from '../../../core/formatter/formatNumber';
import * as React from 'react';

interface PieChartTooltipProps extends React.ClassAttributes<any> {
    data: any;
    legendTitle: Array<any>;
    unit: Array<string>;
    fractionDigits?: number;
}

export class PieChartTooltip extends React.Component<PieChartTooltipProps, {}>  {

    constructor(props: any) {
        super(props);
    }

    render() {
        const { active, payload, label } = this.props.data;
        let { legendTitle, unit, fractionDigits } = this.props;
        legendTitle = legendTitle || [];
        unit = unit || [];
        fractionDigits = fractionDigits >= 0 ? fractionDigits : 2;
        if (active) {
            // console.log(this.props.data);
            const ttStyle: any = {
                /*backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '5px', boxShadow: '6px 6px 29px -4px rgba(0,0,0,0.75)',
                padding: '5px 10px'*/padding: '2px 4px', margin: 0, whiteSpace: 'nowrap', display: 'flex', flexDirection: 'row',
                alignItems: 'baseline', fontSize: '0.9em'
            };
            const toolTipp: Array<any> = [];
            if (label) {
                toolTipp.push(<div style={{ ...ttStyle, ...{ fontWeight: 'bold' } }} key={'tooltip_label'}>{label}</div>);
            }
            if (Array.isArray(payload)) {
                payload.forEach((element: any, idx: number) => {
                    const bColor = element.color || (element.payload ? element.payload.fill : null);
                    // const nameIdx = element.payload.key;
                    // const info = nameIdx && legendTitle[nameIdx - 1] ? legendTitle[nameIdx - 1] : element.name;
                    toolTipp.push(
                        <div style={ttStyle} key={`tooltip_${idx}`}>
                            <div style={{ width: 10, height: 10, backgroundColor: bColor, marginRight: 5 }} />
                            <div><strong>{`${element.name || ''}:`}</strong> {`${formatNumber(element.value, fractionDigits)} ${unit[idx] || ''}`}</div>
                        </div>
                    );
                });
            }
            return toolTipp;
        }

        return null;
    }
}
